<template>
    <eod-card flat>
        <template v-slot:header>
            <v-card-title class="text-body-1 pb-4">
            <eod-btn  class="ml-2" @click="selectMeasurementTypeDialog = true" color="primary" depressed rounded small><v-icon left>mdi-plus</v-icon>Toevoegen</eod-btn>
            </v-card-title>
        </template>
            <v-card-text>
                <eod-expansion-panels v-if="value && value.length > 0">
                    <v-expansion-panel v-for="measurementType in value" :key="measurementType.id">
                        <v-expansion-panel-header>
                            <div class="d-flex align-items-center">
                            {{measurementType.name}}
                            <template v-if="measurementType.hardwareId && measurementType.hardwareId != ''">
                                 | {{ measurementType.hardwareId }}
                                </template>
                            <v-spacer></v-spacer>
                             <v-btn @click.stop="deleteItem(measurementType)" color="error" icon small><v-icon small>mdi-trash-can-outline</v-icon></v-btn>
                             </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <eod-text-field v-if="showHardwareId" label="Hardware ID" v-model="measurementType.hardwareId" dense outlined hide-details></eod-text-field>
                            <v-card-title class="text-body-1 pb-4 px-0">Standaard instellingen
                                <eod-btn  class="ml-2" @click="addIndicativeValue(measurementType)" color="primary" depressed rounded small><v-icon left>mdi-plus</v-icon>Toevoegen</eod-btn>
                            </v-card-title>
                            <table class="w-100">
                                <thead>
                                    <tr>
                                    <th class="text-left px-2 py-2" width="260">Van</th>
                                    <th class="text-left px-2 py-2" width="260">Tot</th>
                                    <th class="text-left px-2 py-2">Waarde</th>
                                    <th class="text-left px-2 py-2" width="40"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(setting, settingIndex) in measurementType.settings" :key="measurementType.id+'_'+settingIndex">
                                        <td class="text-left px-2 py-2">
                                            <eod-text-field type="date" clearable hide-details :value="setting.starttime?$moment(setting.starttime).format('YYYY-MM-DD'):null" :rules="[
                                                val => (!checkBothFilled(val, setting.endtime)?(measurementType.name+': Instelling \'van\' en \'tot\' moeten beide ingevuld zijn, of beide leeg zijn'):true), 
                                                val => (!checkOverlap(measurementType, settingIndex)?(measurementType.name+': \'van\' en \'tot\' van verschillende instellingen mogen niet overlappen!'):true), 
                                                val => (val && val >= setting.endtime?(measurementType.name+': \'Van\' moet kleiner zijn dan \'tot\''):true), 
                                                val => (!val && measurementType.settings.filter(item => (!item.starttime && !item.endtime)).length > 1?(measurementType.name+': Er mag slechts 1 instelling geen \'Van\' en \'Tot\' hebben'):true)
                                            ]" @input="val => {measurementType.settings[settingIndex].starttime = val;updateMeasurementType(measurementType)}"></eod-text-field>
                                        </td>
                                        <td class="text-left px-2 py-2">
                                            <eod-text-field type="date" clearable hide-details :value="setting.endtime?$moment(setting.endtime).format('YYYY-MM-DD'):null"  @input="val => {measurementType.settings[settingIndex].endtime = val;updateMeasurementType(measurementType)}"></eod-text-field>
                                        </td>
                                        <td class="text-left px-2 py-2">
                                            <eod-text-field type="number" v-model="setting.value" hide-details :rules="[val => $validator.required(val, measurementType.name+': Instelling waarde')]" @input="updateMeasurementType(measurementType)">
                                                <template v-slot:append>
                                                    <!-- #1518: een meetwaardetype zonder eenheid mag de hele v-for niet laten
                                                         klappen (TypeError op unit.name maakte titels én waardeveld onzichtbaar). -->
                                                    <div class="px-2" v-if="measurementType.unit">
                                                    {{ measurementType.unit.name }} / 15 min
                                                    </div>
                                                </template>
                                            </eod-text-field>
                                        </td>
                                        <td class="text-left px-2 py-2">
                                            <v-btn @click.stop="deleteSetting(measurementType, settingIndex)" color="error" icon small><v-icon small>mdi-trash-can-outline</v-icon></v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </eod-expansion-panels>
                <v-alert v-else type="info" text>Geen instellingen gevonden voor geselecteerde asset</v-alert>
            </v-card-text>
            <eod-object-selector multiple v-if="selectMeasurementTypeDialog" v-model="selectMeasurementTypeDialog" :disabled="value?value.map(item => item.id):[]" endpoint="measurementTypes" label="Kies een meetwaarde" :fields="['id','name','unit{id name}']" @click="addMeasurementType"></eod-object-selector>
        </eod-card>
        
</template>

<script>
import eodObjectSelector from './eod-object-selector.vue';

export default{
    components:{
        eodObjectSelector
    },
    props:{
        value: Array,
        showHardwareId: Boolean
    },
    data: () => {
        return {
            selectMeasurementTypeDialog:false,
        }
    },
    methods:{
        updateMeasurementType(measurementType){
            const val = this.value.map(item => item.id == measurementType.id?measurementType:item);
            this.$emit('input', val);
        },
        checkOverlap(measurementType, checkIndex){
            const check = measurementType.settings[checkIndex];
            if(!check.starttime){
                return true;
            }
            for (let i = 0; i < measurementType.settings.length; i++) {
                if(i === checkIndex){
                    continue;
                }

                const toCheck = measurementType.settings[i];
                if(toCheck.starttime){
                    if(check.starttime < toCheck.endtime && check.endtime > toCheck.starttime){
                        return false;
                    }
                }
            }

            return true;
        },
        checkBothFilled(val1, val2){
            if((val1 && val2) || (!val1 && !val2)){
                return true;
            }

            return false;
        },
        deleteSetting(measurementType, index){
            measurementType.settings.splice(index, 1);
            this.updateMeasurementType(measurementType);
        },
        deleteItem(item){
            const val = this.value;
            for (let i = 0; i < val.length; i++) {
                if(val[i].id == item.id){
                    val.splice(i, 1);
                };
            }
            this.$emit('input', val);
        },
        addIndicativeValue(measurementType){
            if(!measurementType.settings){
                measurementType.settings = [];
            }

            measurementType.settings.push({
                starttime: null,
                endtime: null,
                value: null,
            });

            const val = this.value.map(item => item.id == measurementType.id?measurementType:item);
            this.$emit('input', val);
        },
        addMeasurementType(items){
            let val = this.value;

            if(!val){
                val = [];
            }

            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                if(!val.map(measurementType => measurementType.id).includes(item.id)){
                    val.push(item);
                } else {
                    this.$toaster.notify({
                            type: 'warning',
                            title: this.$t('Bestaande meetwaarde'),
                            body: this.$t('Meetwaarde reeds gekoppeld aan asset')
                        });
                }
            }
    
            this.selectMeasurementTypeDialog = false;
    
            this.$emit('input', val);
        },
    }
}
</script>